import React from 'react';

const InvoiceManagement = React.lazy(() => import('pages/InvoiceManagement/pages/InvoiceManagement'));

const invoiceManagementRoute = [
  {
    path: '/purchase-invoice-ledger',
    exact: true,
    name: 'Bảng kê mua vào',
    function: 'SL_PURCHASE_INVOICE_LEDGER_VIEW',
    component: InvoiceManagement,
  },
  {
    path: '/sales-invoice-ledger',
    exact: true,
    name: 'Bảng kê bán ra',
    function: 'SL_SALES_INVOICE_LEDGER_VIEW',
    component: InvoiceManagement,
  },
  {
    path: '/purchase-invoice-management',
    exact: true,
    name: 'Hóa đơn đầu vào',
    function: 'SL_PURCHASE_INVOICE_VIEW',
    component: InvoiceManagement,
  },
  {
    path: '/invoice-management',
    exact: true,
    name: 'Hóa đơn đầu ra',
    function: 'SL_SALES_INVOICE_VIEW',
    component: InvoiceManagement,
  },
];

export default invoiceManagementRoute;
